<template>
  <div>
    <div class="head">
      <div class="headbar">
        <div class="container">
          <div class="head-lt">
            <a>欢迎回来到沃德珠宝！</a>
          </div>
          <div class="head-md webCSS">
            <marquee direction="left">
              温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
              1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
              2、实际到货后， 货品“地点”将变更为”HK”。
              3、下单即视为可以接受货品7个工作日之内到港。
              4、货品质量与香港现货库存一致。
            </marquee>
          </div>
        </div>
      </div>
      <div class="head-nav">
        <div class="header">
          <div class="header-lt">
            <div class="logo">
              <a href>
                <img src="/static/img/img/logo.png" />
              </a>
            </div>
          </div>
          <div class="header-ce">
                    <div class="nav">
                        <ul>
                            <li @click="goPage('Home')">首页</li>
                            <li @click="goPage('DiamondSearch')">GIA裸钻</li>
                            <li @click="goPage('MyCar')">我的购物车</li>
                            <li @click="goPage('MyOrder')">我的订单</li>
                            <li @click="goPage('Calculator', true)">计算器</li>
                            <li @click="goPage('FeedBack', true)">问题反馈</li>
                            <li @click="goPage('ChangePass')">修改密码</li>
                            <li @click="loginOut">注销登录</li>
                        </ul>
                    </div>
                </div>
        </div>
      </div>
    </div>
    <div class="war">
        <div class="content">
                <div class="FeedBack-main">
                    <div class="FeedBack-describe" v-if="webConfig.web_custommall_diamond_describe">{{webConfig.web_custommall_diamond_describe}}</div>
                    <div class="FeedBack-name">{{webConfig.web_custommall_diamond_contact}}</div>
                    <div class="FeedBack-name" v-if="webConfig.web_custommall_diamond_phone">
                        <a :href="'tel:' + webConfig.web_custommall_diamond_phone" class="FeedBack-mobile">{{webConfig.web_custommall_diamond_phone}}</a>
                    </div>
                    <div class="FeedBack-code">
                        <div class="FeedBack-code-info">
                            <img v-if="contactCode" :src="contactCode" class="image-full">
                        </div>
                        <div class="FeedBack-code-text">扫二维码，进行反馈</div>
                    </div>
                </div>
            </div>
    </div>
    <div class="board" style="display: none">
      <div class="board_title">
        <i class="fa fa-file-audio-o" aria-hidden="true"></i>公告栏
        <span>Notice Board</span>
        <a class="board_close"></a>
      </div>
      <p>
        温馨提示：ECO肉眼干净，EC1 90%肉眼干净，EC2肉眼不干净
        1、未到货品的“地点”一栏显示为”ind”，已到货品显示”HK”，预计3-7个工作日到香港，并不提供具体预计到货时间查询。
        2、实际到货后， 货品“地点”将变更为”HK”。
        3、下单即视为可以接受货品7个工作日之内到港。
        4、货品质量与香港现货库存一致。
      </p>
    </div>
  </div>
</template>
<script>
import Core from '@/until/core'
export default {
  name: 'FeedBack',
  data () {
    return {}
  },
  components: {},
  watch: {},
  computed: {
    ossPath () {
      return this.$store.state.ossPath
    },
    webConfig () {
      return this.$store.state.config
    },
    contactCode () {
      const data = JSON.parse(
        this.webConfig.web_custommall_diamond_code || '{}'
      )
      if (
        this.ossPath &&
        data.path &&
        data.path.indexOf('#OSS_OBJECT_URL') === 0
      ) {
        return this.ossPath + data.path.replace('#OSS_OBJECT_URL', '')
      }
      return ''
    }
  },
  filters: {},
  methods: {
    goPage (name, bool) {
                const that = this
                if (bool) {
                    return Core.goNext(name, that.$route.params)
                }
                Core.loginExist().then(res => {
                    if (res) {
                        return Core.goNext(name, that.$route.params)
                    }
                    Core.goNext('StaffLogin', that.$route.params)
                })
            },
    loginOut () {
                Core.onRemoveToken()
                Core.goNext('StaffLogin', this.$route.params, true)
            },
    goBack () {
      Core.goBack()
    }
  },
  mounted () {}
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../node_modules/swiper/dist/css/swiper.min.css";
@import "../../static/css/yellow.css";
@import "../../static/css/font-awesome.css";
.nav {
  height: 90px;
}
.header-ce {
  width: 1000px;
}
.header-ce ul li {
  float: left;
  line-height: 90px;
  width: 100px;
  text-align: center;
}
.Home-banner {
  width: 100%;
  height: 600px;
  overflow: hidden;
  background-color: #fff;
}
.btn-hk {
  color: #fff;
  padding: 8px 16px;
  line-height: 100px;
  background: #f268a3;
  border-radius: 2px;
  font-size: 13px;
}

.modelBox {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.65);
  overflow: hidden;
  z-index: 999;
}

.model {
  position: absolute;
  width: 1000px;
  height: 500px;
  margin: 0 auto;
  left: 0;
  right: 0;
  top: calc(50% - 350px);
  z-index: 9999;
  text-align: center;
  padding: 50px 0;
}

.closed {
  display: block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: absolute;
  right: 150px;
  top: 1200px;
  text-align: center;
  line-height: 22px;
  background: #e0b12f;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

.timeer {
  text-align: center;
  position: absolute;
  bottom: 0;
  width: 100px;
  margin: auto;
  left: 0;
  right: 0;
  line-height: 40px;
  font-size: 14px;
  color: #ffeb3b;
  font-size: 30px;
  border-radius: 5px;
}
.FeedBack-main {
  width: 800px;
  margin:0 auto;
}
.FeedBack-describe {
  width: 100%;
  text-align: center;
  line-height: 40px;
  font-size: 26px;
  white-space: pre-wrap;
  margin-bottom: 20px;
  padding: 0 26px;
}
.FeedBack-name {
  width: 100%;
  line-height: 40px;
  font-size: 26px;
  text-align: center;
}
.FeedBack-code {
  width: 100%;
  text-align: center;
  margin-top: 40px;
}
.FeedBack-code-info {
  margin: 0 auto;
  width: 300px;
  height: 300px;
}
.FeedBack-code-text {
  width: 100%;
  line-height: 50px;
  font-size: 22px;
  color: #ccc;
}
.FeedBack-mobile {
  color: #2035fe;
}
</style>



// WEBPACK FOOTER //
// src/components/FeedBack.vue